import screen from './Edit';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Equipe/Edit/index.js